export default {
	project_name: 'Escola do Varejo',
}
